{
	"approve": {
		"action": "Approva e pubblica",
		"after_list": "Gli studenti possono segnalare un errore entro le {{time}} di {{day}}, poi la graduatoria è definitiva. Ai candidati arriva un'email con l'indirizzo della pagina.",
		"after_title": "Cosa succede dopo",
		"blocked": "Non puoi ancora approvare: {{conditions}}.",
		"cancel": "Annulla",
		"changed": "È nata la versione {{number}} della graduatoria: l'abbiamo ricaricata. Controllala e approva di nuovo.",
		"confirm": "Approva e pubblica la versione {{number}}",
		"errors": {
			"already": "La graduatoria è già approvata.",
			"default": "Non siamo riusciti ad approvare la graduatoria. Riprova.",
			"not_approvable": "Mancano ancora delle condizioni: {{conditions}}."
		},
		"not_public_list": "I nomi, l'ISEEU, i crediti, chi non è ammesso e le domande escluse.",
		"not_public_title": "Non diventa pubblico",
		"public_list": "Le tre liste DSU: protocollo, posizione, punteggio ed esito. Chi è solo nella lista 70% non compare.",
		"public_title": "Diventa pubblico",
		"success": "Graduatoria pubblicata.",
		"summary": "La pagina pubblica si apre subito.",
		"title": "Approvare la graduatoria?"
	},
	"columns": {
		"name": "Cognome e nome",
		"notes": "Note",
		"outcome": "Esito",
		"position": "Pos.",
		"protocol": "Prot.",
		"score": "Punteggio",
		"standing": "Vale la domanda"
	},
	"conditions": {
		"all_met": "Tutte le condizioni per approvare sono soddisfatte.",
		"applications_reviewed": "Ogni domanda ha la validità confermata o un problema segnalato",
		"calculation_done": "Il calcolo è stato fatto",
		"call_closed": "Il bando è chiuso",
		"flags_closed_or_expired": "Le segnalazioni sono chiuse o il loro termine è scaduto",
		"flags_detail_missing_term": "{{count}} da chiudere e il termine non è ancora fissato: mancano le festività nelle regole.",
		"flags_detail_open_one": "{{count}} segnalazione da chiudere, entro le 24:00 del {{day}}.",
		"flags_detail_open_other": "{{count}} segnalazioni da chiudere, entro le 24:00 del {{day}}.",
		"intake_closed": "Il caricamento delle domande dirette è chiuso",
		"met": "Soddisfatta",
		"no_pending_recalculation": "Nessun ricalcolo in attesa: la graduatoria è aggiornata",
		"not_met": "Non ancora",
		"recalculation_failing": "Il ricalcolo non è andato a buon fine e il sistema riprova a ogni minuto. Se non si sblocca, apri una richiesta di assistenza.",
		"recalculation_waiting": "Ricalcolo in corso dal {{since}}: la graduatoria si aggiorna da sola, di solito in meno di un minuto.",
		"review_detail_one": "{{count}} domanda da confermare.",
		"review_detail_other": "{{count}} domande da confermare.",
		"review_link": "Apri le domande in attesa",
		"title": "Condizioni per approvare",
		"waits": "La graduatoria si calcola da sola quando le condizioni ci sono."
	},
	"control_lists": {
		"doctoral": "Dottorandi e specializzandi",
		"excluded": "Escluse",
		"freshers": "Matricole",
		"later_years": "Anni successivi",
		"not_admitted": "Non ammessi",
		"q70": "Lista quota 70%",
		"q70_dsu_seat": "Quota 70% con posto DSU"
	},
	"details": {
		"title": "Calcolo e versioni"
	},
	"disability_priority_revoked": "Priorità tolta",
	"excluded": {
		"empty": "Nessuna domanda esclusa.",
		"standing": "Vale la domanda con protocollo {{protocol}}",
		"subtitle": "La stessa persona ha un'altra domanda valida: conta l'ultima inviata."
	},
	"header": {
		"fingerprint": "Impronta",
		"line": "Versione {{number}} · {{reason}} · calcolata il {{when}} · {{count}} domande valide",
		"rules": "Versione delle regole",
		"version": "Versione"
	},
	"late": "Dopo il bando",
	"lists": {
		"doctoral": {
			"subtitle": "I dottorandi e gli specializzandi con diritto alla quota 30%, per punteggio. Con gli anni successivi si dividono il resto dei posti DSU, per punteggio. È pubblica.",
			"title": "Dottorandi e specializzandi"
		},
		"empty": "Nessuna domanda in questa lista.",
		"freshers": {
			"subtitle": "Gli iscritti al primo anno con diritto alla quota 30%, per punteggio: il 25% dei posti DSU, arrotondato per eccesso. È pubblica.",
			"title": "Matricole"
		},
		"later_years": {
			"subtitle": "Gli iscritti agli anni successivi con diritto alla quota 30%, per punteggio. Con i dottorandi si dividono il resto dei posti DSU, per punteggio. È pubblica.",
			"title": "Anni successivi"
		},
		"q70": {
			"subtitle": "Chi può avere un posto della quota 70%: tutte e tre le liste per punteggio. Non è pubblica.",
			"title": "Lista quota 70%"
		},
		"q70_dsu_seat": {
			"subtitle": "Chi è nella lista quota 70% ma ha già un posto DSU: mantiene la sua posizione e non prende un posto della quota 70%. Non è pubblica."
		},
		"seats_one": "{{count}} posto",
		"seats_other": "{{count}} posti",
		"shared_with": "in comune con {{list}}",
		"unfilled_q30_one": "{{count}} posto DSU non coperto in tutta la quota 30%",
		"unfilled_q30_other": "{{count}} posti DSU non coperti in tutta la quota 30%",
		"unfilled_q70_one": "{{count}} posto non coperto",
		"unfilled_q70_other": "{{count}} posti non coperti"
	},
	"not_admitted": {
		"empty": "Nessuna domanda non ammessa.",
		"missing_data": "Dati mancanti",
		"quota": "Quota {{quota}}",
		"reason": {
			"cfu_below_min": "crediti sotto il minimo",
			"excluded_by_student": "quota esclusa dallo studente",
			"iseeu_above": "ISEEU sopra la soglia",
			"ispeu_above": "ISPEU sopra la soglia",
			"missing_data": "dato mancante",
			"offsite_not_met": "condizione di fuori sede non soddisfatta",
			"other": "requisito non soddisfatto"
		}
	},
	"outcome": {
		"assigned": "Posto assegnato · quota {{quota}}",
		"forfeited": "Decaduta",
		"no_seat": "In graduatoria, senza posto",
		"withdrawn": "Ritirata: ha accettato un posto in un'altra struttura"
	},
	"page_switch": {
		"cancel": "Annulla",
		"confirm": "Disabilita la pagina",
		"description": "Usalo solo per un errore di pubblicazione. La pagina dice che la graduatoria è temporaneamente non disponibile, gli studenti non possono inviare segnalazioni e le versioni già pubblicate restano nel fascicolo. Quando la riabiliti, gli studenti hanno di nuovo le 48 ore intere.",
		"disable": "Disabilita la pagina",
		"disabled_done": "Pagina disabilitata.",
		"enable": "Riabilita la pagina",
		"enabled": "Pagina riabilitata.",
		"errors": {
			"disable": "Non siamo riusciti a disabilitare la pagina. Riprova.",
			"enable": "Non siamo riusciti a riabilitare la pagina. Controlla la graduatoria e riprova."
		},
		"reason": "Che errore hai trovato?",
		"reason_hint": "Il motivo viene registrato. Almeno {{min}} caratteri.",
		"reason_required": "Scrivi almeno {{min}} caratteri.",
		"since": "Disabilitata il {{when}}",
		"title": "Disabilitare la pagina pubblica?"
	},
	"page_title": "Graduatoria",
	"provisional_view": {
		"back": "Torna ai bandi",
		"banner": "Classifica provvisoria: dati dichiarati, non ancora verificati. Non è la graduatoria e può cambiare fino alla chiusura del bando.",
		"closed": "Il bando non è più aperto: vale la graduatoria di controllo.",
		"computed": "Calcolata il {{when}}, a ogni apertura della pagina: non viene salvata né pubblicata e gli studenti non la vedono.",
		"empty": "Nessuna domanda valida per ora.",
		"error": "Non siamo riusciti a calcolare la classifica provvisoria. Riprova.",
		"open": "Classifica provvisoria"
	},
	"published": {
		"address": "Pagina pubblica",
		"badge_disabled": "Pagina disabilitata",
		"badge_final": "Definitiva",
		"badge_review": "Pubblicata",
		"copied": "Indirizzo copiato.",
		"copy": "Copia l'indirizzo",
		"disabled_title": "La pagina pubblica è disabilitata",
		"final": "La graduatoria è definitiva dal {{when}}",
		"review": "Gli studenti possono segnalare un errore entro le {{time}} di {{day}}",
		"window_runs": "Finché la pagina è disabilitata la graduatoria non diventa definitiva. Quando la riabiliti, le segnalazioni riaprono per le 48 ore intere."
	},
	"reason": {
		"assignment_forfeited": "Decadenza dall'assegnazione",
		"disability_priority_restored": "Priorità per disabilità ridata",
		"disability_priority_revoked": "Priorità per disabilità tolta",
		"first_calculation": "Primo calcolo",
		"flag_resolved": "Segnalazione chiusa",
		"forfeit_annulled": "Correzione di un errore materiale",
		"late_application": "Domanda dopo il bando",
		"ministry_authorization": "Autorizzazione del Ministero",
		"scrolling": "Scorrimento",
		"transcription_corrected": "Trascrizione corretta",
		"withdrawal_undone": "Domanda tornata valida"
	},
	"reports": {
		"link": "Errori segnalati dagli studenti"
	},
	"rules_note": "Le liste e il punteggio seguono le regole DiSCo del bando, sezione 5: tre liste DSU ordinate per punteggio, il 25% dei posti DSU alle matricole e il resto ad anni successivi e dottorandi insieme.",
	"seat_origin": {
		"equipped_priority": "Posto con priorità per disabilità",
		"ministry_authorization": "Posto DSU autorizzato dal Ministero",
		"other_list": "Posto DSU lasciato libero dall'altro gruppo"
	},
	"state": {},
	"verifying": "Valutata con i dati dichiarati",
	"versions": {
		"published": "Pubblicata",
		"title": "Versioni",
		"unpublished": "Non pubblicata"
	}
}
